module.exports = __webpack_public_path__ + "static/media/LowScoreBoy.7db47ff1.svg";